import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
interface DownloadFeatureGoodsResponse {
  FilePath: string;
  FileName: string;
}

/**
 * 表紙特集商品選定情報ダウンロードサービス
 * @export DownloadFeatureGoodsService
 * @class DownloadFeatureGoodsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DownloadFeatureGoodsService extends PlessJsonResponderSub<DownloadFeatureGoodsResponse> {
  downloadList: any[];
  private calbak: (data: any) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DownloadFeatureGoodsService
   */
  private getBody(): PlessRequest {
    const searchObj = {
      DownloadList: {
        combination: this.downloadList.map(item => ({
          parameter: {
            CatalogId: item.CatalogId,
            MediumName: item.MediumName,
            Feature: item.Feature,
            ClassName: item.ClassName,
            MiddleClass: item.MiddleClass,
            PCode: item.PCode,
            GuideGoodsName: item.GuideGoodsName,
            GuideStandardName: item.GuideStandardName,
            PricePattern: item.PricePattern,
            ThisTimeSupplyPrice: item.ThisTimeSupplyPrice,
            ThisTimeCostPrice: item.ThisTimeCostPrice,
            PredictPlanNum: item.PredictPlanNum,
            PlanNum: item.PlanNum,
            PlanSupplyBudget: item.PlanSupplyBudget,
            GPR: item.GPR,
            TagName: item.TagName,
            Status: item.Status,
            Selector: item.Selector,
            Remarks: item.Remarks
          }
        }))
      }
    }

    return new PlessRequest({search: searchObj});
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof DownloadFeatureGoodsService
   */
  execute(downloadList: any[], f?: (data: any) => void): void {
    this.downloadList = downloadList;
    if (f) this.calbak = f;
    this.send('downloadFeatureGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DownloadFeatureGoodsService
   */
  success(data: DownloadFeatureGoodsResponse) {
    if (this.calbak) this.calbak(data);
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
